// extracted by mini-css-extract-plugin
export default {"ExtensionContentHeader":"_ExtensionContentHeader--nSMrZ","ExtensionContentBody":"_ExtensionContentBody--vu6th"};